import '../../css/wallet/WalletLoading.css';

function WalletLoading({theme}) {
  return (
    <div className="dffdeer32">
      <div className="contentDiv calc60 padding12">
        <div className="dkfmvow33">
          <div className={`fkvmlcxds shimmer ${theme}`}></div>
          <div className={`dfgbvccxs shimmer ${theme}`}></div>
        </div>

        {[
          ...Array.from([1, 2]).map((i) => (
            <div className="kdjjfmvcx" key={i}>
              <div className={`kkdjmvcx4 shimmer ${theme}`}></div>
              <div className={`dmmmvkmcx shimmer ${theme}`}></div>
            </div>
          )),
        ]}
      </div>
    </div>
  );
}

export default WalletLoading;
